import React from 'react'
import { motion } from 'framer-motion' // Import Motion
import English from '../../assets/English.jpg';
import French from '../../assets/French.jpg';
import Lingala from '../../assets/Lingala.jpg';
import Swahili from '../../assets/Swahili.jpg';
import { FaDownload } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import MyCV from '../../assets/Prince_Mwenyemali_E-CV.pdf'

const Languages = () => {
    // Parent container animation logic
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Delay between each card
                duration: 2 // Total section fade duration
            }
        }
    };

    // Individual item animation logic
    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { 
            opacity: 1, 
            y: 0, 
            transition: { duration: 2, ease: "easeOut" } // 2 second duration as requested
        }
    };

    return (
        <section className="toolkit">
            <motion.div 
                className="container h"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
                variants={containerVariants}
            >
                <motion.h2 className="h2-dark center" variants={itemVariants}>
                    Bridging Connections Through Linguistic Versatility
                </motion.h2>
                <div className="divider">
                    <div className="v-primary vider"></div>
                    <div className="v-dark vider"></div>
                    <div className="v-primary vider"></div>
                </div>
                <div className="wrapper shadow">
                    <div className="description">
                        
                        <div className="cards">
                            <motion.div className="card" variants={itemVariants}>
                                <div className="card-image-container">
                                    <img src={English} alt='Digital design' className='card-image'/>
                                </div>
                                <h3 className="card-head-dark">
                                    English | Full Professional Mastery
                                </h3>
                                <div className="description">
                                    <p className="card-text-dark">
                                        Complete fluency in technical documentation and corporate correspondence. Zero limitations in complex engineering environments.
                                    </p>
                                </div>
                            </motion.div>

                            <motion.div className="card" variants={itemVariants}>
                                <div className="card-image-container">
                                    <img src={Swahili} alt='Technical engineering' className='card-image'/>
                                </div>
                                <h3 className="card-head-dark">
                                    Swahili | Native Proficiency 
                                </h3>
                                <div className="description">
                                    <p className="card-text-dark">
                                        Deep linguistic and cultural mastery. Seamless, nuanced communication for high-level local and regional engagement.
                                    </p>
                                </div>
                            </motion.div>

                            <motion.div className="card" variants={itemVariants}>
                                <div className="card-image-container">
                                    <img src={French} alt='Digital design' className='card-image'/>
                                </div>
                                <h3 className="card-head-dark">
                                    French | Professional Foundation 
                                </h3>
                                <div className="description">
                                    <p className="card-text-dark">
                                        Solid foundation for business interactions and technical instructions. Supporting multi-language project requirements with clarity.
                                    </p>
                                </div>
                            </motion.div>

                            <motion.div className="card" variants={itemVariants}>
                                <div className="card-image-container">
                                    <img src={Lingala} alt='Digital design' className='card-image'/>
                                </div>
                                <h3 className="card-head-dark">
                                    Lingala | Verbal Specialist
                                </h3>
                                <div className="description">
                                    <p className="card-text-dark">
                                        Proficient in fluid verbal exchange and collaborative discussion. Expert at building immediate rapport within regional teams.
                                    </p>
                                </div>
                            </motion.div>

                        </div>
                    </div>
                </div>
            </motion.div>
            <div className="space"></div>
            
            <div className="btns-center">
                <button className="secondary btn">
                    {/* Updated 'to' prop to use the imported MyCV variable */}
                    <Link to={MyCV} target="_blank" rel="noopener noreferrer">
                        My Resume {' '} <FaDownload className='setting' />
                    </Link>
                </button>
            </div>

        </section>
    )
}

export default Languages;